import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// attach token from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("es_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ---------- components ----------
export const createFaq = (data) => api.post("/faq", data).then(r => r.data);
export const getFaq = (id) => api.get(`/faq/${id}`).then(r => r.data);
export const updateFaq = (id, data) => api.patch(`/faq/${id}`, data).then(r => r.data);
export const deleteFaq = (id) => api.delete(`/faq/${id}`).then(r => r.data);

export const createPixel = (data) => api.post("/pixel", data).then(r => r.data);
export const createPSPixel = (data) => api.post("/ps_pixel", data).then(r => r.data);
export const bulkCreatePSPixels = (data) => api.post("/ps_pixel/bulk", data).then(r => r.data);
export const createGAPixel = (data) => api.post("/ga_pixel", data).then(r => r.data);
export const getPixel = (id) => api.get(`/pixel/${id}`).then(r => r.data);
export const updatePixel = (id, data) => api.patch(`/pixel/${id}`, data).then(r => r.data);
export const deletePixel = (id) => api.delete(`/pixel/${id}`).then(r => r.data);
export const getPixelHits = (id) => api.get(`/pixel/${id}/hits`).then(r => r.data);
export const getPixelStats = (id, days = 30) => api.get(`/pixel/${id}/stats?days=${days}`).then(r => r.data);
export const pixelCsvUrl = (id) => `${API}/pixel/${id}/hits.csv`;

export const createRichtext = (data) => api.post("/richtext", data).then(r => r.data);
export const getRichtext = (id) => api.get(`/richtext/${id}`).then(r => r.data);
export const updateRichtext = (id, data) => api.patch(`/richtext/${id}`, data).then(r => r.data);
export const deleteRichtext = (id) => api.delete(`/richtext/${id}`).then(r => r.data);

export const createGallery = (data) => api.post("/gallery", data).then(r => r.data);
export const getGallery = (id) => api.get(`/gallery/${id}`).then(r => r.data);
export const updateGallery = (id, data) => api.patch(`/gallery/${id}`, data).then(r => r.data);
export const deleteGallery = (id) => api.delete(`/gallery/${id}`).then(r => r.data);

export const getPixelFunnel = (id, days = 30) =>
  api.get(`/pixel/${id}/funnel?days=${days}`).then(r => r.data);

export const myComponents = (params = {}) =>
  api.get("/my/components", { params }).then(r => r.data);

// ---------- media ----------
export const uploadMedia = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/media", fd, { headers: { "Content-Type": "multipart/form-data" } }).then(r => r.data);
};
export const listMedia = () => api.get("/media").then(r => r.data);
export const deleteMedia = (id) => api.delete(`/media/${id}`).then(r => r.data);

// ---------- folders + tags ----------
export const listFolders = () => api.get("/folders").then(r => r.data);
export const createFolder = (data) => api.post("/folders", data).then(r => r.data);
export const updateFolder = (id, data) => api.patch(`/folders/${id}`, data).then(r => r.data);
export const deleteFolder = (id) => api.delete(`/folders/${id}`).then(r => r.data);
export const listTags = () => api.get("/tags").then(r => r.data);

// ---------- auth ----------
export const authLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then(r => r.data);
export const authMe = () => api.get("/auth/me").then(r => r.data);

// ---------- sysadmin ----------
export const listCustomers = () => api.get("/sysadmin/customers").then(r => r.data);
export const getCustomer = (id) => api.get(`/sysadmin/customers/${id}`).then(r => r.data);
export const createCustomer = (data) => api.post("/sysadmin/customers", data).then(r => r.data);
export const updateCustomer = (id, data) => api.patch(`/sysadmin/customers/${id}`, data).then(r => r.data);
export const deleteCustomer = (id) => api.delete(`/sysadmin/customers/${id}`).then(r => r.data);
export const listAllUsers = () => api.get("/sysadmin/users").then(r => r.data);
export const sysadminCreateUser = (data) => api.post("/sysadmin/users", data).then(r => r.data);
export const sysadminResetPassword = (uid, password) =>
  api.post(`/sysadmin/users/${uid}/reset-password`, { password }).then(r => r.data);

// ---------- team ----------
export const teamList = () => api.get("/team/users").then(r => r.data);
export const teamCreate = (data) => api.post("/team/users", data).then(r => r.data);
export const teamUpdate = (id, data) => api.patch(`/team/users/${id}`, data).then(r => r.data);
export const teamDelete = (id) => api.delete(`/team/users/${id}`).then(r => r.data);
